import { HELPCENTER_BASE_URL } from '../constants/url';
import { post } from '../utils/fetch';
import { GroupBookingSubmissionData, CreateGroupBookingResponse } from '../components/GroupBookingForm/index.types';

export async function createGroupBooking(data: GroupBookingSubmissionData): Promise<CreateGroupBookingResponse> {
    const url = `${HELPCENTER_BASE_URL}/groupbooking`;
    return post(url, {
        body: JSON.stringify(data),
    });
}